"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const __1 = require("../../..");
const styles_1 = require("./styles");
exports.BodyPopup = (props) => {
    function renderHeader() {
        var _a;
        return (react_1.default.createElement(styles_1.ModalBodyHeader, null,
            react_1.default.createElement(styles_1.ModalBodyHeaderTitle, null, (_a = props.header) !== null && _a !== void 0 ? _a : react_1.default.createElement("h4", null, props.title)),
            react_1.default.createElement(__1.Col, { className: "col-2 text-right" },
                react_1.default.createElement(__1.Button, { icon: react_1.default.createElement(fa_1.FaTimes, null), onClick: props.onClose, borderless: true }))));
    }
    function renderBody() {
        return react_1.default.createElement("div", { className: "body" }, props.children);
    }
    function renderFooter() {
        var _a;
        if (!props.footer) {
            return (react_1.default.createElement(styles_1.ModalBodyFooter, null,
                react_1.default.createElement(__1.Button, { onClick: props.onClose, type: "primary", "data-dismiss": "modal", title: (_a = props.closeButtonTitle) !== null && _a !== void 0 ? _a : "Fechar" })));
        }
        else
            return props.footer;
    }
    return (react_1.default.createElement("div", { className: "modal-dialog" },
        react_1.default.createElement("div", { className: "modal-content modal-body" },
            renderHeader(),
            renderBody(),
            renderFooter())));
};
